import cache from 'bz-stores/lib/diary-cache-store';
import view from 'bz-stores/lib/diary-view-store';
import Locks from 'bz-stores/lib/locks';
import { action, observable, runInAction } from 'mobx';
import {
  type AppointmentResponse,
  DiaryListResponse,
  type GeneralCustomerResponse
} from 'tm3-core/api.dtos';

export enum EActivePopover {
  cancellation = 'cancellation',
  doNext = 'doNext',
  none = 'none',
  quickbill = 'quickbill',
  event = 'event'
}

export interface IQuickbillOptions {
  id: number;
  status: number;
  deleteCase: boolean;
}

class DiaryPopoverStore {
  @observable activePopover: EActivePopover = EActivePopover.none;
  @observable anchorEl: HTMLElement | null = null;
  @observable selected = null;
  @observable appointmentDoNext = null;
  @observable patientDoNext = null;
  @observable quickbillOptions: Partial<IQuickbillOptions> = {};
  @observable callback?: (() => void) | null = null;
  @action
  showPopoverForCustomer(
    appt: AppointmentResponse,
    customer: GeneralCustomerResponse,
    callback?: () => void
  ) {
    const {
      reference,
      mobileTelephone,
      email,
      smsEnabled,
      title,
      forename,
      surname,
      gender,
      insuranceNumber,
      groupReference,
      status,
      registrationDate
    } = customer;
    const mapped = {
      customerReference: reference,
      customerMobileTelephone: mobileTelephone,
      customerEmail: email,
      customerSMSEnabled: smsEnabled,
      customerTitle: title,
      customerForename: forename,
      customerSurname: surname,
      customerGender: gender,
      insuranceNumber: insuranceNumber,
      groupReference: groupReference,
      customerStatus: status,
      customerRegistrationDate: registrationDate
    };

    return this.showPopover(
      EActivePopover.event,
      new DiaryListResponse({ ...mapped, ...appt }),
      undefined,
      callback
    );
  }

  @action
  showPopover(
    activePopover: EActivePopover,
    appt: any,
    selection?: HTMLElement,
    callback?: () => void
  ) {
    let { allRooms, allLocations, allPractitioners } = cache;
    appt.room = allRooms.find((x) => x.id === appt.roomId);
    appt.location = allLocations.find((x) => x.id === appt.locationId);
    appt.practitioner = allPractitioners.find((x) => x.id === appt.practitionerId);
    appt.apptStockColour = appt.hexColour;
    if (selection) this.anchorEl = selection;
    this.activePopover = activePopover;
    this.selected = appt;
    this.callback = callback;
  }

  @action.bound
  async hidePopover() {
    try {
      if (this.selected) await Locks.actions.releaseLock('A', this.selected.id);
      try {
        this.callback?.();
      } catch {}
    } catch (e) {
    } finally {
      this.selected = null;

      runInAction(() => {
        this.activePopover = EActivePopover.none;
        this.anchorEl = null;
        this.selected = null;
        this.callback = null;
      });
    }
  }

  @action
  doNextPrompt(appointment, patient) {
    if (!view.showDoNextScreen) {
      this.hidePopover();
      return;
    }

    // appointment = (@get('appointments') || []).filter((x) -> x.id is parseInt(apptId))
    // return unless appointment[0]?
    this.appointmentDoNext = appointment;
    this.patientDoNext = patient;
    this.activePopover = EActivePopover.doNext;
  }

  @action
  quickbill(id: number, status: number, deleteCase: boolean) {
    this.activePopover = EActivePopover.quickbill;
    this.quickbillOptions = { id, status, deleteCase };
  }

  @action
  cancellation(id: number, status: number, deleteCase: boolean) {
    this.activePopover = EActivePopover.cancellation;
    this.quickbillOptions = { id, status, deleteCase };
  }
}
export default new DiaryPopoverStore();
